import { useMutation } from '@tanstack/react-query';
import { signupWithSchoolIdDirect } from '@timetable/api';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

async function sendSignupEmail(userId: string) {
  try {
    const res = await fetch(`${SUPABASE_URL}/functions/v1/send-signup-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify({ userId }),
    });
    if (!res.ok) console.warn('[sendSignupEmail] Non-OK response:', res.status);
  } catch (err) {
    console.warn('[sendSignupEmail] Failed:', err);
  }
}

export function useSignup() {
  return useMutation({
    mutationFn: (signupData: { email: string; password: string; name: string; schoolId: string }) => {
      return signupWithSchoolIdDirect(signupData);
    },
    // onSuccess: intentionally does NOT set auth or navigate.
    // New users are created with status='pending' and must be approved by an admin before logging in.
    onSuccess: (data) => {
      if (data?.user?.id) {
        sendSignupEmail(data.user.id);
      }
    },
    onError: (error: Error) => {
      console.error('Signup failed:', error);
    },
  });
}
